import React from "react";
import { Image } from "react-bootstrap";
import AdSpace from "../../images/Frame 1948765911.png";
import AdTablet from "../../images/Ad 250717-01.png";
const RightSection = () => {
  const goToWebsite = () => {
    window.open("http://ez1020.com/", "_blank");
  };
  return (
    <div className="d-flex flex-column align-items-end justify-content-between h-auto adspace-sec">
      <Image src={AdSpace} alt="Desktop Ad" onClick={goToWebsite} style={{ cursor: "pointer" }} className="ad-image-desktop position-relative " />
      <Image src={AdTablet} alt="Tablet Ad" onClick={goToWebsite} style={{ cursor: "pointer" }} className="ad-image-tablet position-relative" />
    </div>
  );
};


export default RightSection;